module.exports = __webpack_public_path__ + "img/bg-symptom1.4fc91d56.png";